import { useEffect, useState } from "react";
import type { JSX } from "react";

import { parseVersionPayload, VERSION_UNAVAILABLE, type AdminVersion } from "./admin-version";

import { api } from "@/lib/api";


export function AdminVersionFooter(): JSX.Element {
  const [version, setVersion] = useState<AdminVersion | null>(null);
  const [unavailable, setUnavailable] = useState(false);

  useEffect(() => {
    let cancelled = false;
    void (async (): Promise<void> => {
      try {
        const url = new URL("/version.json", window.location.origin).href;
        const payload: unknown = await api.get(url, {
          headers: { "Cache-Control": "no-store", Pragma: "no-cache" },
        });
        const parsed = parseVersionPayload(payload);
        if (!parsed) throw new Error("version unread");
        if (!cancelled) setVersion(parsed);
      } catch {
        if (!cancelled) {
          setVersion(null);
          setUnavailable(true);
        }
      }
    })();
    return (): void => {
      cancelled = true;
    };
  }, []);

  return (
    <footer
      className="border-t border-gray-200 bg-white px-4 py-2 text-xs text-gray-500"
      data-testid="admin-version-footer"
    >
      {unavailable || !version ? (
        unavailable ? (
          <span data-testid="admin-version-unavailable">{VERSION_UNAVAILABLE}</span>
        ) : null
      ) : (
        <span className="inline-flex items-center gap-2">
          <span data-testid="admin-version-sha">{version.shortSha}</span>
          <span data-testid="admin-version-time">{version.buildTime}</span>
          <button
            type="button"
            className="rounded px-1.5 py-0.5 text-gray-600 hover:bg-gray-100"
            data-testid="admin-version-copy"
            onClick={() => {
              void navigator.clipboard.writeText(version.fullSha);
            }}
          >
            Copy
          </button>
        </span>
      )}
    </footer>
  );
}
